import React from 'react'

export default function Kanban() {
  return (
    <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_5322_5806)">
        <path d="M0.5 3.5V3C0.223858 3 0 3.22386 0 3.5H0.5ZM6.5 3.5H7C7 3.22386 6.77614 3 6.5 3V3.5ZM6.5 14.5V15C6.77614 15 7 14.7761 7 14.5H6.5ZM0.5 14.5H0C0 14.7761 0.223858 15 0.5 15V14.5ZM8.5 3.5V3C8.22386 3 8 3.22386 8 3.5H8.5ZM14.5 3.5H15C15 3.22386 14.7761 3 14.5 3V3.5ZM14.5 9.5V10C14.7761 10 15 9.77614 15 9.5H14.5ZM8.5 9.5H8C8 9.77614 8.22386 10 8.5 10V9.5ZM0 1H7V0H0V1ZM8 1H15V0H8V1ZM0.5 4H6.5V3H0.5V4ZM6 3.5V14.5H7V3.5H6ZM6.5 14H0.5V15H6.5V14ZM1 14.5V3.5H0V14.5H1ZM8.5 4H14.5V3H8.5V4ZM14 3.5V9.5H15V3.5H14ZM14.5 9H8.5V10H14.5V9ZM9 9.5V3.5H8V9.5H9Z" fill="#2B2B2B" />
      </g>
      <defs>
        <clipPath id="clip0_5322_5806">
          <rect width="15" height="15" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
